<template>
    <v-card
        :min-height="minHeight"
        rounded="0"
        flat
        :style="{backgroundImage: background ? `url(${background})` : 'none'}"
        class="main-page-form-wrapper d-flex align-center justify-center"
        style="overflow: inherit; z-index: 5"
        :class="{
            'sf-wrapper--light': $conf.public.layout.searchForm.light,
            'sf-wrapper--bottom': $conf.public.layout.searchForm.bottom,
        }"
    >
        <search-form-tabs
            ref="searchFormTabs"
            v-model="activeTabProduct"
            :city-id="cityId"
            choose-agent
            class="my-7 my-md-0"
            @change="onTabChange"
        />
    </v-card>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import SearchFormTabs from '~src/components/searchFormTabs.src'
    import {AuthInfoMixin} from '~src/mixins/authInfoMixin.src'

    @Component({
        components: {SearchFormTabs},
    })
    export class MainPageFormWrapper extends AuthInfoMixin {
        @Prop() img
        @Prop({default: 500}) minHeight
        @Prop() cityId

        activeTabProduct = null

        created() {
            const index = this.activeProducts.findIndex((product: string) => product === this.$route.query.tab)
            this.activeTabProduct = index !== -1 ? index : 0
            useHead({
                link: this.images.map(href => ({
                    rel: 'preload',
                    href,
                    as: 'image',
                })) as any[],
            })
        }

        onTabChange(product: string) {}

        get background() {
            return this.img || this.backgrounds[this.activeProducts[this.activeTabProduct]]
        }

        get backgrounds() {
            const bg = (caption, defaultBackground) =>
                this.$filters.srcHost(cmsStore.homePageSettings.searchFormBackgrounds[caption] || defaultBackground)
            return {
                hotels: bg('hotel', '/home-bg.jpg'),
                transfers: bg('transfer', '/home-bg-transfers.jpg'),
                activities: bg('activity', '/home-bg-activities.jpg'),
                flights: bg('flight', '/home-bg-flights.jpg'),
                packages: bg('package', '/packages-bg.jpg'),
                //TODO - background image
                tours: bg('tour', '/packages-bg.jpg'),
                carsRent: bg('car', '/home-bg-car.jpg'),
                insurance: bg('insurance', '/home-bg-insurance.jpg'),
                visa: bg('visa', '/home-bg-visa.jpg'),
                extraServices: bg('extraService', '/home-bg-extra-services.jpg'),
                conferenceHall: bg('conference_hall', '/home-bg-conference-hall.jpg'),
                catering: bg('catering', '/home-bg-catering.jpg'),
                cruises: bg('cruises', '/home-bg-cruises.jpg'),
                tour: bg('tour', '/home-bg.jpg'),
            }
        }

        get images() {
            return [...new Set(this.activeProducts.map(product => this.backgrounds[product]))]
        }
    }

    export default MainPageFormWrapper
</script>
